import { supabase } from './supabase';
import { UpstagingGeneration } from '../types/restyle';

export const upstagingService = {
  async createGeneration(
    generationData: Omit<UpstagingGeneration, 'id' | 'created_at'>
  ): Promise<UpstagingGeneration> {
    const { data, error } = await supabase
      .from('upstaging_generations')
      .insert({ ...generationData })
      .select()
      .single();

    if (error) {
      console.error('Error creating upstaging generation:', error);
      throw new Error(error.message);
    }

    return data;
  },

  async getGenerations(userId: string): Promise<UpstagingGeneration[]> {
    const { data, error } = await supabase
      .from('upstaging_generations')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching upstaging generations:', error);
      throw new Error(error.message);
    }

    return data;
  },

  async getRoomTypes(): Promise<any[]> {
    const { data, error } = await supabase.from('room_types').select('*');

    if (error) {
      console.error('Error fetching room types:', error);
      throw new Error(error.message);
    }

    return data;
  },
}; 